import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import Preview from './Preview';
import ProgressBar from '../../../../view/ProgressBar';
import {ContractCreate} from '../../../../view/Messages';
import Data from '../../../../data/StateDeedOfSaleOfMotorVehicle.json';
import FormError from '../../../../view/FormError';
import {Currency, UnCurrency} from '../../../../model/Helper';
import Meta from '../../../../model/Meta';

class DeedOfSaleOfMotorVehicleStep4 extends Component {

	constructor(props) {
		super(props);
		this.state = Data;
		
		this.handleChange = this.handleChange.bind(this);
    }

    componentWillMount() {

		if(localStorage.getItem(this.state.formId)===null) {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

		let data = JSON.parse(localStorage.getItem(this.state.formId));

		if(data){
			this.setState({
				details: data.details,
				formError: data.formError
			},			
				()=>{				
					localStorage.setItem(this.state.formId, JSON.stringify(this.state));

					this.errorHandle();
				}
			);
		} else {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

    }

    componentDidMount() {
		$('html, body').animate({scrollTop: 0}, 300);
	}

	handleChange(e, radioName=null) {

		const target = e.target;
		let value = target.type === 'checkbox' ? target.checked : target.value;
		const name = radioName ? radioName : target.name;

		if(name==="price") {
			value = UnCurrency(value);
			if(value.length>15){
				value = this.state.details.property.price;
			}
        }

		this.setState({
			details: {
				property: {
                    ...this.state.details.property,
                    [name]: value
                },
				seller: this.state.details.seller,
				buyer: this.state.details.buyer,
			},
			formFocus: `property_${name}`
		},
			()=>{
				//console.log("Handle user change: ", this.state.formFocus);
				//console.log("Focus target: ", this.state.formFocus+this.state.formFocusBuyerNo);
				this.setState(this.state);
				localStorage.setItem(this.state.formId, JSON.stringify(this.state));
                this.errorHandle();
                this.elementsShowHide();

			}
		);
	}
	
	errorHandle(callback = null) {
		// Check if we have a user buyer
        let errorArray = [];
        
		if(!this.state.details.property.price) {
            let err = {
                "message": `Please enter price.`
            }
            errorArray.push(err);
        }
        
        this.setState({
            formError: errorArray
        },(i)=>{
            localStorage.setItem(this.state.formId, JSON.stringify(this.state));
            this.checkCompleteness();	
            this.elementsShowHide();				
        })

	}

    checkCompleteness() {

		if(this.state.formError.length>0) {
            $(".next").addClass("disabled");
            $(".form-error").removeClass("d-none");
		} else {
            $(".next").removeClass("disabled");
            $(".form-error").addClass("d-none");
		}

	}

	elementsShowHide(i) {

		if(typeof this.state.details.buyer[i] === 'undefined') {
			// Do nothing
		} else {

			if(this.state.details.buyer[i].legalPersonality==="Natural Person"){
				$(".buyer_"+i+" .natural-person").removeClass("d-none");

				/**
				 * Hide everything else is buyer is below legal age
				 */
				if(this.state.details.buyer[i].isLegalAge==="Yes"){
					$(".buyer_"+i+" .requireLegalAge").removeClass("d-none");
					$(".buyer_"+i+" .isNotLegalAge").addClass("d-none");
				} else {
					$(".buyer_"+i+" .requireLegalAge").addClass("d-none");
					$(".buyer_"+i+" .isNotLegalAge").removeClass("d-none");
				}

				/**
				 * Hide representative if no representative
				 */
				if(
					this.state.details.buyer[i].buyerHasRepresentative==="Yes" && 
					this.state.details.buyer[i].isLegalAge==="Yes"){
					$(".buyer_"+i+" .requireHasRepresentative").removeClass("d-none");
				} else {
					$(".buyer_"+i+" .requireHasRepresentative").addClass("d-none");
				}

				/**
				 * Hide spouse block if single
				 */
				if(
					this.state.details.buyer[i].isLegalAge==="Yes" && 
					this.state.details.buyer[i].buyerMaritalStatus==="Married"){
					$(".buyer_"+i+" .requireMarried").removeClass("d-none");
				} else {
					$(".buyer_"+i+" .requireMarried").addClass("d-none");
				}

			} else {
				$(".buyer_"+i+" .natural-person").addClass("d-none");
			}

			/**
			 * Show/hide corporation block
			 */
			if(this.state.details.buyer[i].legalPersonality === "Corporation"){
				$(".buyer_"+i+" .corporation").removeClass("d-none");
			} else {
				$(".buyer_"+i+" .corporation").addClass("d-none");	
			}

			/**
			 * Hide error block if there is no error
			 */
			if(this.state.formError.length>0){
                $(".form-error").removeClass("d-none");
                $(".new-buyer").addClass("d-none");
			} else {
                $(".form-error").addClass("d-none");
                $(".new-buyer").removeClass("d-none");
            }
            

		}

	}

    render() {
		const meta = {
			title: "Cost of vehicle - Deed of sale of motor vehicle",
			description: "Amount of Vehicle - Create your custom Deed of sale of motor vehicle"
				}
        return(
            <div className="page page-inner page-contract">
				<Meta {...meta}/>
				<div className="">
					<div className="">					
						<div className="row">
							<div className="col-12 col-md-5">
								<h4 className="page-title pt-0 pb-3">{this.state.formName}</h4>
								
                                <ContractCreate />
								
								<ProgressBar percentage={Math.floor((4/5)*100)} />

                                <form>
                                    
                                    <div className="form-group">
										<label htmlFor="price">
											<span className="font-weight-bold">How much is the selling price of the motor vehicle? <span className="red asterisk">*</span></span>
										</label>
										<input className="form-control" name="price" type="text" onChange={this.handleChange} value={Currency(this.state.details.property.price)} placeholder="(e.g. 1,000,000)" />
									</div>

                                </form>

                                {/** Navs */}
								<div className="nav-step mt-4">
									<p className="p-0 m-0">Step 4/5</p>
									<FormError errors={this.state.formError} />
									<div className="row">
										<div className="col-6">
											<Link to={this.state.formPath+"/3"} className="btn btn-lightblue w-100">Back</Link>
										</div>
										<div className="col-6">
											<Link to={this.state.formPath+"/5"} className="btn btn-lightblue disabled next w-100">Next</Link>
										</div>
									</div>
								</div>
                            
                            </div>

                            <div className="col-12 col-md-7 right-preview">
								<Preview {...this.state} />
							</div>
                         
                        </div>
                    </div>
                </div>
            </div>

        )
    }
    
}

export default DeedOfSaleOfMotorVehicleStep4;


// WEBPACK FOOTER //
// ./src/pages/contracts/business/deed-of-sale-of-motor-vehicle/DeedOfSaleOfMotorVehicleStep4.js